import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileDevPageVideoStagePrimis from './primis/MobileDevPageVideoStage';
const MobileDevPageVideoStage = ({ safety ='off'  })=>{
    const primisOff = useFlag('ads_primis_perf');
    if (primisOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageVideoStagePrimis, {
        safety: safety
    });
};
MobileDevPageVideoStage.displayName = 'MobileDevPageVideoStage';
export default MobileDevPageVideoStage;
